/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_e0a71eff{position:relative}.root_e0a71eff.snap_e0a71eff{position:absolute;top:0;left:0;right:0;bottom:0}.dragOver_e0a71eff:after{content:' ';display:block;pointer-events:none;border:2px solid "},{"theme":"neutralTertiaryAlt","defaultValue":"#c8c8c8"},{"rawString":";position:absolute;top:0;left:0;bottom:0;right:0}\n"}]);
export const root = "root_e0a71eff";
export const snap = "snap_e0a71eff";
export const dragOver = "dragOver_e0a71eff";